export const defaultParams = {
  bgColor: 'transparent',
  color: 'transparent',
  borderColor: 'transparent',
  icon: undefined,
  label: 'Неизвестно',
};
